import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API
const proxyAI = process.env.VUE_APP_ENV === 'local' ? '/proxy_ai_api' : process.env.VUE_APP_AI_API


export default {
  getPhotoTemplateData: payload => {
    return api.get(proxyApi + '/v3/photo/id_photo_template', payload)
  },
  getUsePhotoCount: payload => {
    return api.get(proxyApi + '/v3/photo/id_photo_count', payload)
  },
  getUserUploadPhoto: () => {
    return api.get(proxyApi + '/v3/photo/${photoKey}')
  },
  editPhotoBeauty: payload => {
    return api.post(proxyApi + '/v3/photo/cut_check_pic', payload)
  },
  getNoWatermarkedPhoto: (payload) => {
    return api.post(proxyApi + '/v3/photo/take_cut_pic', payload)
  }
}
